const categories = [
    {
        "name": 'Climbing',
        "type": 'CLIMBING',
    },
    {
        "name": 'Climbing Rental',
        "type": 'CLIMBING_RENTAL',
    },
    {
        "name": 'Climbing Extra',
        "type": 'CLIMBING_EXTRA',
    },
    {
        "name": 'Safari',
        "type": 'SAFARI',
    },
    {
        "name": 'Safari Activity',
        "type": 'SAFARI_ACTIVITY',
    },
    {
        "name": 'Mainland Accommodation',
        "type": 'EXTRA_ACCOMMODATION',
    },
    {
        "name": 'Mainland Day Trip',
        "type": 'MAINLAND',
    },
    {
        "name": 'Mainland Transfers',
        "type": 'TRANSFER',
    },
    {
        "name": 'Island Accommodation',
        "type": 'ISLAND',
    },
    {
        "name": 'Island Transfers',
        "type": 'ISLAND_TRANSFER',
    },
    {
        "name": 'Island Day Trip',
        "type": 'ISLAND_DAY_TRIP',
    },
    {
        "name": 'Flight',
        "type": 'FLIGHT',
    },
    {
        "name": 'Airport VIP Service',
        "type": 'AIRPORT_VIP_SERVICE',
    },
    {
        "name": 'Additional Service',
        "type": 'ADDITIONAL_SERVICE',
    },
    {
        "name": 'Custom',
        "type": 'CUSTOM',
    }
]

export const findInvoiceCategoriesFromBreakdown = (breakdownCost) => {
    let categories = [
        {
            name: 'Custom',
            type: 'CUSTOM',
        },
    ]

    if (breakdownCost.climbingCost && breakdownCost.climbingCost.routes.length) {
        categories.push({
            name: 'Climbing',
            type: 'CLIMBING',
        })
    }

    if (breakdownCost.dayTripsCost && breakdownCost.dayTripsCost.totalAmount) {
        categories.push({
            name: 'Mainland Day Trip',
            type: 'MAINLAND',
        })
    }

    if (breakdownCost.safariCost && breakdownCost.safariCost.totalAmount) {
        categories.push({
            name: 'Safari',
            type: 'SAFARI',
        })
    }

    if (breakdownCost.islandCost && breakdownCost.islandCost.totalAmount) {
        categories.push({
            name: 'Island Accommodation',
            type: 'ISLAND',
        })
    }

    if (breakdownCost.transferCost && breakdownCost.transferCost.totalAmount) {
        categories.push({
            name: 'Mainland Transfers',
            type: 'TRANSFER',
        })
    }

    if (breakdownCost.flightTickets && breakdownCost.flightTickets.totalAmount) {
        categories.push({
            name: 'Flight',
            type: 'FLIGHT',
        })
    }

    if (
        breakdownCost.extraAccommodationCost &&
        breakdownCost.extraAccommodationCost.totalAmount
    ) {
        categories.push({
            name: 'Mainland Accommodation',
            type: 'EXTRA_ACCOMMODATION',
        })
    }

    if (
        breakdownCost.airportVipServices &&
        breakdownCost.airportVipServices.totalAmount
    ) {
        categories.push({
            name: 'Airport VIP Service',
            type: 'AIRPORT_VIP_SERVICE',
        })
    }
    return categories;
}

export const findCategoriesServicesBreakdown = () => {
    return categories
}
